import { ConditionViewerItem, Text } from '@customerio/pluma-components/react';
import type { UnknownNode } from '../../types';
import { getIconForNode } from '../data-source-icon';

interface UnknownConditionProps {
  node: UnknownNode;
}

/**
 * A stored condition this viewer has no words for, as Ember's condition list
 * says it: "Condition type not supported", under the critical marker.
 *
 * The row names neither the condition's keys nor its values. The keys mean
 * nothing to the reader, and a value can be a person's data.
 */
export function UnknownCondition({ node }: UnknownConditionProps) {
  return (
    <ConditionViewerItem icon={getIconForNode(node)} data-testid="condition-viewer-unsupported">
      <Text as="span" color="secondary">
        Condition type not supported
      </Text>
    </ConditionViewerItem>
  );
}
